// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__nz7rv","item":"PaymentsMobile_item__2XV0W","label":"PaymentsMobile_label__2xNv-","amount":"PaymentsMobile_amount__w-Mq_"};